import { render } from "./ActivePlayer.vue?vue&type=template&id=3ae2f8a1&scoped=true&bindings={}"
import script from "./ActivePlayer.vue?vue&type=script&lang=ts"
export * from "./ActivePlayer.vue?vue&type=script&lang=ts"

import "./ActivePlayer.vue?vue&type=style&index=0&id=3ae2f8a1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3ae2f8a1"

export default script